import { makeStyles } from '@mui/styles';

export const buttonStyles = (disabled=false) => { return {
    borderRadius: '8px',
    fontFamily: 'Lato',
    fontStyle: 'normal',
    textTransform: 'none',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '32px',
    textWrap:'noWrap',
    height: '56px',
    paddingLeft:'20px',
    paddingRight:'20px',
    borderColor : disabled ? '#C3C9F1' : '#214DCE',
    color: disabled ? '#C3C9F1' : '#214DCE',
};};

export const buttonStylesGreen = (disabled=false) => { return {
    borderRadius: '8px',
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: '600',
    textTransform: 'none',
    fontSize: '12px',
    lineHeight: '32px',
    textWrap:'noWrap',
    height: '56px',
    paddingLeft:'20px',
    paddingRight:'20px',
    backgroundColor: disabled ? '#BCE7CB' : '#5CC889',
    borderColor: disabled ? '#BCE7CB' : '#5CC889',
    color: disabled ? '#8FD7AB' : '#FFFFFF',
    '&:hover': {
        backgroundColor: disabled ? '#BCE7CB' : '#5CC889',
    },
    '&:active': {
        backgroundColor: disabled ? '#BCE7CB' : '#8FD7AB',
    },
};};

export const iconEndAdornment= (windowSize) => { return {
    marginRight: '-14px',
    paddingLeft: '0px',
    marginLeft: '0px',
    width:'40px',
    borderBottomLeftRadius: '0px',
    borderTopLeftRadius: '0px',
    borderBottomRightRadius: '8px',
    borderTopRightRadius: '8px',
    height:windowSize=='medium'?'56px':'40px',
};};

export const buttonStylesRed = (disabled=false) => { return {
    borderRadius: '8px',
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: '600',
    textTransform: 'none',
    fontSize: '12px',
    lineHeight: '32px',
    height: '56px',
    textWrap:'noWrap',
    paddingLeft:'20px',
    paddingRight:'20px',
    backgroundColor: disabled ? 'rgba(236, 91, 86, 0.3)' : '#EC5B56',
    borderColor: disabled ? 'rgba(236, 91, 86, 0.3)' : '#EC5B56',
    color: disabled ? '#EC5B56' : '#FFFFFF',
    '&:hover': {
        backgroundColor: disabled ? 'rgba(236, 91, 86, 0.3)' : '#EC5B56',
    },
    '&:active': {
        backgroundColor: disabled ? '#EC5B56' : '#EC5B56',
    },
};};

export const buttonStylesBlue = (disabled=false) => { return {
    borderRadius: '8px',
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '32px',
    textTransform: 'none',
    paddingLeft:'20px',
    paddingRight:'20px',
    height: '56px',
    backgroundColor: disabled ? '#C3C9F1' : '#214DCE',
    color: disabled ? '#9BA6E7' : '#FFFFFF',
    '&&:hover': {
        backgroundColor: disabled ? '#C3C9F1 !important' : '#214DCE !important',
        color: disabled ? '#9BA6E7 !important' : '#7083DD !important',

    },
    '&&:active': {
        backgroundColor: disabled ? '#C3C9F1 !important' : '#073AB7 !important',
        color: disabled ? '#9BA6E7 !important' : '#7083DD !important',
    },
};
};

export const useStyles = makeStyles(() => ({
// const useStyles = makeStyles((theme) => ({
    button: {
        backgroundColor: '#f50057',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#d50000',
        },
    },
    disabledButton: {
        backgroundColor: '#ccc',
        color: '#000',
    },
}));

const identitystyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems : 'flex-start',
    padding : '0px',
    gap : '24px',
    position : 'absolute',
    width : '748px',
    height : '483px',
    left : '537px',
    top : '166px',
};

const twoinputstyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '24px',
    width: '748px',
    height: '48px',
    flex: 'none',
    order: 1,
    alignSelf: 'stretch',
    flexGrow: 0,};

const countryinputstyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px',
    width: '362px',
    height: '48px',
    flex: 'none',
    order: 0,
    flexGrow: 1,
};

const cardinputstyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px',
    width: '362px',
    height: '48px',
    flex: 'none',
    order: 1,
    flexGrow: 1,
};

const allcarduploadstyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '8px',
    width: '748px',
    height: '192px',
    flex: 'none',
    order: 2,
    flexGrow: 0,
};

const titlestyle = {
    width: '226px',
    height: '44px',
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '34px',
    lineHeight: '44px',
    letterSpacing: '-0.75px',
    color: '#272D3C',
    flex: 'none',
    order: 0,
    flexGrow: 0,
};

const telechrgestyle = {
    fontFamily: 'Lato',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    margin:0,
    letterSpacing: '-0.0044em',
    color: '#475063',
};

const resultocrstyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '16px',
    alignSelf: 'stretch',
};

const outresultocr = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '8px',
    width: '748px',
    height: '60px',
    flex: 'none',
    order: 0,
    alignSelf: 'stretch',
    flexGrow: 0,
};

const outsidesubmitbtnstyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    padding: '0px',
    gap: '24px',
    width: '748px',
    height: '56px',
    flex: 'none',
    order: 4,
    alignSelf: 'stretch',
    flexGrow: 0,
};

const stylebuttonsubmit = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    color:'white',
    alignItems: 'center',
    padding: '12px 24px 12px 20px',
    gap: '8px',
    width: '185px',
    height: '56px',
    background: 'rgba(33, 77, 206, 1)',
    borderRadius: '8px',
    flex: 'none',
    order: 0,
    flexGrow: 0,
};
export const uploadDocStyles = {stylebuttonsubmit,outsidesubmitbtnstyle,outresultocr,resultocrstyle,identitystyle,twoinputstyle,countryinputstyle,cardinputstyle,allcarduploadstyle,titlestyle,telechrgestyle};
